export default __webpack_public_path__ + "static/media/gallery-wip-pommel_06.5c4a560a.jpg";